import { applyPreferredSpeaker } from '@/features/devices/services/audio-output.service'
let audioContext: AudioContext | null = null
let messageAudio: HTMLAudioElement | null = null
let reactionAudio: HTMLAudioElement | null = null

// Initialize audio elements for file-based sounds
function initAudioElements() {
  if (typeof window === 'undefined') return
  
  if (!messageAudio) {
    messageAudio = new Audio('/freesound_community-positive-response-81640.mp3')
    applyPreferredSpeaker(messageAudio)
    messageAudio.volume = 0.5
    messageAudio.playbackRate = 1.0 // Normal speed for messages
  }
  
  if (!reactionAudio) {
    // Use same file but different pitch for reactions - creates "WowSpark" effect
    reactionAudio = new Audio('/freesound_community-positive-response-81640.mp3')
    applyPreferredSpeaker(reactionAudio)
    reactionAudio.volume = 0.6
    reactionAudio.playbackRate = 1.8 // Much higher pitch for magical spark sound
  }
}

export function playNotificationSound() {
  try {
    initAudioElements()
    
    // Play the MP3 sound for messages
    if (messageAudio) {
      messageAudio.currentTime = 0
      messageAudio.play().catch(() => {
        // Fallback to generated sound if file playback fails
        playGeneratedNotificationSound()
      })
    } else {
      playGeneratedNotificationSound()
    }
  } catch (error) {
    console.warn("Failed to play notification sound:", error)
  }
}

export function playReactionSound() {
  try {
    initAudioElements()
    
    // Play the pitched-up MP3 sound for reactions (creates WowSpark/MagicPop effect)
    if (reactionAudio) {
      reactionAudio.currentTime = 0
      reactionAudio.play().catch((err) => {
        console.warn("Reaction sound failed:", err)
      })
    }
  } catch (error) {
    console.warn("Failed to play reaction sound:", error)
  }
}

// Generated fallback sound for messages - pleasant chime
function playGeneratedNotificationSound() {
  try {
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext
    if (!AudioContextClass) return

    if (!audioContext) {
      audioContext = new AudioContextClass()
    }

    const ctx = audioContext
    const now = ctx.currentTime

    // Pleasant chime sound (two-tone)
    const osc1 = ctx.createOscillator()
    const osc2 = ctx.createOscillator()
    const gainNode = ctx.createGain()

    osc1.type = "sine"
    osc1.frequency.setValueAtTime(523.25, now) // C5
    osc1.frequency.exponentialRampToValueAtTime(659.25, now + 0.1) // E5

    osc2.type = "sine"
    osc2.frequency.setValueAtTime(659.25, now + 0.05) // E5
    osc2.frequency.exponentialRampToValueAtTime(783.99, now + 0.15) // G5

    gainNode.gain.setValueAtTime(0, now)
    gainNode.gain.linearRampToValueAtTime(0.15, now + 0.02)
    gainNode.gain.exponentialRampToValueAtTime(0.001, now + 0.4)

    osc1.connect(gainNode)
    osc2.connect(gainNode)
    gainNode.connect(ctx.destination)

    osc1.start(now)
    osc2.start(now + 0.05)
    osc1.stop(now + 0.4)
    osc2.stop(now + 0.45)
  } catch (error) {
    console.warn("Failed to play generated notification sound:", error)
  }
}

